export default __webpack_public_path__ + "0f80bbd45d4328d155af9522051ed6ea.svg";